import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import faviconUrl from "./assets/favicon.png";
import "./i18n";
// Self-hosted fonts — prod CSP is `style-src 'self'` and blocks Google Fonts.
// Bundling the @fontsource packages serves the same WOFF2 files from our origin.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "./index.css";
import { bootstrapTheme } from "./lib/theme";

bootstrapTheme();

// Set favicon via JS — robust against dev/prod path differences and aggressive
// browser cache (vite hashes the asset URL on rebuild).
{
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/png";
  link.href = faviconUrl;
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
